import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { NavigationBlockModalSchema } from '../types/NavigationBlockModalSchema';

const initialState: NavigationBlockModalSchema = {
    showDialog: false,
    navBlocked: false,
    allowedRoutes: [],
};

export const NavigationBlockModalSlice = createSlice({
    name: 'NavigationBlockModal',
    initialState,
    reducers: {
        setNavigationBlocked: (
            state,
            action: PayloadAction<
                boolean | { blocked: boolean; allowedRoutes?: string[] }
            >,
        ) => {
            if (typeof action.payload === 'boolean') {
                state.navBlocked = action.payload;
                if (!action.payload) {
                    state.allowedRoutes = [];
                }
            } else {
                state.navBlocked = action.payload.blocked;
                state.allowedRoutes = action.payload.allowedRoutes || [];
            }
        },
        setShowDialog: (state, action: PayloadAction<boolean>) => {
            if (action.payload && !state.navBlocked) return;
            state.showDialog = action.payload;
        },
    },
});

export const { actions: navigationBlockModalActions } =
    NavigationBlockModalSlice;
export const { reducer: navigationBlockModalReducer } =
    NavigationBlockModalSlice;
